import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router'
import styled, { withTheme } from 'styled-components'
import LanguageProvider from '../../containers/LanguageProvider/LanguageProvider'
import messages from './messages'
import { Logo } from '../'
import { OptionsHOC } from '../../hocs'
import FooterCopyright from './FooterCopyright'
import FooterExternal from './FooterExternal'

const StyledFooter = styled.footer`
  z-index: 1;
  height: 100px;
  clear: both;
  background: var(--clr-footer-bg);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  a {
    max-height: 40px;
    width: 30%;
    margin-bottom: 1rem;
    text-align: center;
  }
  p {
    font-size: 0.75em;
    font-weight: 500;
    color: var(--clr-grey-3-to-white);
  }
`

const FooterDefault = ({ getOption, language, createUserEvent, query }) => {
  const logoLink = getOption('footer.logoLink')
  const logoLinkSelf = getOption('footer.logoLinkSelf')
  const logoPadding = getOption('footer.logoPadding')
  const logoImageSrc = getOption('footer.footerLogo')
  const altLogoText = getOption('pageTitle')
  const year = new Date().getFullYear()
  const translated = messages[language]['copyright']
  return (
    <StyledFooter>
      {logoLink ? (
        <a href={logoLink} target={logoLinkSelf ? '_self' : '_blank'}>
          <Logo style={{ padding: logoPadding }} src={logoImageSrc} alt={altLogoText} />
        </a>
      ) : (
        <Link
          to={{ pathname: '/', query }}
          onClick={() =>
            createUserEvent({
              category: 'navigation',
              data: { link_to: '/', source: 'FooterHome' }
            })
          }
        >
          <Logo style={{ padding: logoPadding }} src={logoImageSrc} alt={altLogoText} />
        </Link>
      )}
      <FooterCopyright year={year} text={translated} />
    </StyledFooter>
  )
}

const Footer = props => {
  const { version } = props
  return version === 'v1' ? <FooterDefault {...props} /> : <FooterExternal {...props} version={version} />
}

Footer.propTypes = {
  query: PropTypes.object.isRequired,
  language: PropTypes.string.isRequired,
  getOption: PropTypes.func.isRequired,
  createUserEvent: PropTypes.func.isRequired
}

export default LanguageProvider(withTheme(OptionsHOC(Footer)))



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js